import React from 'react'
import PropTypes from 'prop-types'

import { ParticipantTableHead } from '../components/Table/data'
import BodyContainer from '../components/bodyContainer'

const UserList = ({
  fetchData,
  isLoadingUserList,
  users,
  userCount,
  errorMessage,
  removeError,
  isErrorFetch,
  pageLimitChanged,
  pageChanged,
  success,
  isSuccessRefresh,
  resetSuccessAction,
  searchData,
  onCloseReset,
  errorMessageConfig,
  removeErrorConfig,
}) => {
  return (
    <BodyContainer
      //EtatdisplayMode
      isDisplayMode={false}
      //TableMode
      actionButton={true}
      tableHead={ParticipantTableHead}
      //Commonfields
      globalID={'User'}
      searchPlaceholder={'Rechercher par utilisateur'}
      title={'Gestion utilisateurs'}
      fetchData={fetchData}
      loadingData={isLoadingUserList}
      dataList={users}
      countData={userCount}
      errorMessage={errorMessage || errorMessageConfig}
      removeError={removeError}
      removeErrorConfig={removeErrorConfig}
      isErrorFetch={isErrorFetch}
      pageLimitChanged={pageLimitChanged}
      pageChanged={pageChanged}
      searchData={searchData}
      onCloseReset={onCloseReset}
      resetSuccessAction={resetSuccessAction}
      success={success}
      isSuccessRefresh={isSuccessRefresh}
      isUser={true}
    />
  )
}
UserList.propTypes = {
  users: PropTypes.array,
  fetchData: PropTypes.func,
  isLoadingUserList: PropTypes.bool,
  pageLimitChanged: PropTypes.func,
  pageChanged: PropTypes.func,
  searchKeys: PropTypes.func,
  onCloseReset: PropTypes.func,
  searchData: PropTypes.func,
  success: PropTypes.bool,
  userCount: PropTypes.number,
  errorMessage: PropTypes.string,
  removeError: PropTypes.func,
  isErrorFetch: PropTypes.bool,
  isSuccessRefresh: PropTypes.bool,
  resetSuccessAction: PropTypes.func,
  errorMessageConfig: PropTypes.string,
  removeErrorConfig: PropTypes.func,
}
export default UserList
